module.exports = __webpack_public_path__ + "img/yunnanjingji.c78fa684.png";